import * as React from 'react'
import { TestingMainConnected } from './TestingMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TestingMainExamples = () => {
  return (
    <div className="TestingMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TestingMainConnected />
      </Provider>
    </div>
  )
}
